<ion-header *ngIf="DBservice.ismobile">
  <ion-toolbar>
    <ion-buttons slot="start">
      <!-- defaultHref="/addproduct" -->
      <ion-back-button (click)="modalCtrl.dismiss()" defaultHref=""></ion-back-button>
    </ion-buttons>
    <ion-title>Add Image</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div  *ngIf="img_type != 'attribute'" class="images__container d__flex" [class.flex_direction]="DBservice.ismobile">
    <div cdkDropList (cdkDropListDropped)="drop($event,product_info.product_images)" class="added__images example-list"  *ngIf="product_info && (product_info.product_images && product_info.product_images.length != 0);else no_image">
      <div class="d__flex ion-align-items-center just-s mb10">
        <h5 class="m-0">Images</h5>
        <!-- <ion-button size="small" fill="clear" class="m-0 fnt-12 ion-text-capitalize" (click)="modalCtrl.dismiss('success')">Save</ion-button> -->
      </div>
      <div  class="image__container example-box"  >

          <div cdkDrag *ngFor="let item of product_info.product_images; let i = index;" class="d__flex list">
            <div class="d__flex box_1">
              <ion-thumbnail slot="start">
                <img  [src]="item.filedata ? item.filedata : DBservice.product_img(item.detail_thumbnail)">
              </ion-thumbnail>
              <ion-label>
                <p class="headertexth6">{{item.image_name ? item.image_name : item.filename}}</p>
                <p class="check_box_p"><ion-checkbox (ionChange)="mark_primary($event,i,item,product_info.product_images)" [(ngModel)]="item.is_primary"></ion-checkbox>Mark as primary </p>
              </ion-label>
            </div>
       
            <ion-icon class="box_2 fnt-18 mouse" (click)="remove_img(i,item)" color="danger" src="/assets/icon/delete.svg" slot="end"></ion-icon>
          </div>

      </div>
        <ion-reorder-group *ngIf="false" (ionItemReorder)="reorderList($event)" disabled="false">
          <!--  ((product_info && product_info.product_images && product_info.product_images.length != 0) ? product_info.product_images : DBservice.product_info.upload_images) -->
          <!-- <div class="d__flex  ion-align-items-center gap-10 just-s mb-10 border" *ngFor="let item of product_info.product_images; let i = index;">
            <ion-reorder slot="start"></ion-reorder>
            <div class="image p-10">
              <img *ngIf="item.detail_thumbnail else file_data" [src]="DBservice.product_img(item.detail_thumbnail)">
              <ng-template #file_data>
                <img [src]="item.filedata">
              </ng-template>
            </div>
            <div>
              <div class="mgb-5">
                <p class="m-0 fnt-14" *ngIf="!item.edit">{{item.image_name}}</p>
                <ion-input class="fnt-14" [autofocus]="true" [(ngModel)]="item.image_name" *ngIf="item.edit"></ion-input>
              </div>
              <div class="m-0 fnt-12 gap-10 d__flex ion-align-items-center cursor-pointer" (click)="remove_other(item.product_image)">
                <ion-checkbox [(ngModel)]="item.is_primary"></ion-checkbox> <span>Mark as primary</span>
              </div>
            </div>
            <div class="d__flex ion-align-items-center just-s">
              <ion-button class="edit__button ion-text-capitalize" fill="clear" color="success" size="small" (click)="item.edit = !item.edit">
                <ion-icon color="success" src="/assets/icon/edit.svg"></ion-icon>
              </ion-button>
              <ion-button class="delete__button ion-text-capitalize" fill="clear" color="danger" size="small" (click)="remove_img(i,item)">
                <ion-icon color="danger" src="/assets/icon/delete.svg"></ion-icon>
              </ion-button>
            </div>
          </div> -->
          <ion-item lines="full" class="mouse" *ngFor="let item of product_info.product_images; let i = index;">
            <ion-reorder slot="start"></ion-reorder>
            <ion-thumbnail slot="start">
              <img *ngIf="item.detail_thumbnail" [src]="DBservice.product_img(item.detail_thumbnail)">
              <img *ngIf="!item.detail_thumbnail" [src]="DBservice.product_img(item.detail_thumbnail)">
            </ion-thumbnail>
            <ion-label>
              <p class="headertexth6">{{item.image_name || item.filename}}</p>
              <p class="check_box_p"><ion-checkbox [(ngModel)]="item.is_primary"></ion-checkbox>Mark as primary </p>
              <!-- <div class="m-0 fnt-12 gap-10 d__flex ion-align-items-center cursor-pointer" (click)="remove_other(item.product_image)"> -->
                <!-- <ion-checkbox [(ngModel)]="item.is_primary"></ion-checkbox> <span>Mark as primary</span> -->
              <!-- </div> -->
              <!-- <p><ion-checkbox [(ngModel)]="item.is_primary"></ion-checkbox>Mark as primary </p> -->
            </ion-label>
            <ion-icon class="fnt-18" (click)="remove_img(i,item)" color="danger" src="/assets/icon/delete.svg" slot="end"></ion-icon>
          </ion-item>
        </ion-reorder-group>
      <!-- </div> -->
    </div>
    <ng-template #no_image>
      <div class="added__images">
        <p class="ion-text-center">No Images Found.!</p>
      </div>
    </ng-template>
    <div class="add__image 123">
      <app-image-add (insert_images)="insert_images($event)"></app-image-add>
    </div>
  </div>
  <div *ngIf="img_type == 'attribute'" class="images__container d__flex" [class.flex_direction]="DBservice.ismobile">
    <div  *ngIf="product_info.variant_combination && product_info.variant_combination[edit_index].image_list;else no_image" class="added__images">
      <div cdkDropList (cdkDropListDropped)="drop($event,product_info.product_images)" class="added__images example-list" >
        <div class="d__flex ion-align-items-center just-s mb10">
          <h5 class="m-0">Images</h5>
          <!-- <ion-button size="small" fill="clear" class="m-0 fnt-12 ion-text-capitalize" (click)="modalCtrl.dismiss('success')">Save</ion-button> -->
        </div>
        <div  class="image__container example-box"  >
  
            <div cdkDrag *ngFor="let item of product_info.variant_combination[edit_index].image_list; let i = index;" class="d__flex list">
              <div class="d__flex box_1">
                <ion-thumbnail slot="start">
                  <img [src]="item.filedata ? item.filedata : DBservice.product_img(item.detail_thumbnail)">
                </ion-thumbnail>
                <ion-label>
                  <p class="headertexth6">{{item.image_name ? item.image_name : item.filename}}</p>
                  <p class="check_box_p"><ion-checkbox [(ngModel)]="item.is_primary"></ion-checkbox>Mark as primary </p>
                </ion-label>
              </div>
         
              <ion-icon class="box_2 fnt-18 mouse" (click)="delete_img(i,item)" color="danger" src="/assets/icon/delete.svg" slot="end"></ion-icon>
            </div>
  
        </div>

      </div>

      <div *ngIf="false" class="image__container">
        <ion-reorder-group *ngIf="product_info.variant_combination[edit_index].image_list" (ionItemReorder)="reorderList($event)" disabled="false">
          <!-- <div *ngIf="product_info.variant_combination[edit_index].image_list;else no_image"> -->
              <ion-item lines="full" class="mouse" *ngFor="let item of product_info.variant_combination[edit_index].image_list;index as i">
                  <ion-reorder slot="start"></ion-reorder>
                  <ion-thumbnail slot="start">
                    <img *ngIf="item.detail_thumbnail" [src]="DBservice.product_img(item.detail_thumbnail)">
                    <!-- <img *ngIf="!item.detail_thumbnail" [src]="DBservice.product_img(item.detail_thumbnail)"> -->
                  </ion-thumbnail>
                  <ion-label>
                    <p class="headertexth6">{{item.title}}</p>
                    <!-- <div class="m-0 fnt-12 gap-10 d__flex ion-align-items-center cursor-pointer" (click)="remove_attribute(item.product_image)">
                      <ion-checkbox [(ngModel)]="item.is_primary"></ion-checkbox> <span>Mark as primary</span>
                    </div> -->
                    <p class="check_box_p"><ion-checkbox [(ngModel)]="item.is_primary"></ion-checkbox>Mark as primary </p>
                  </ion-label>
                  
                  <ion-icon class="fnt-18" (click)="delete_img(i,item)" color="danger" src="/assets/icon/delete.svg" slot="end"></ion-icon>
              </ion-item>
          <!-- </div> -->
        </ion-reorder-group>
      </div>
    </div>
    <ng-template #no_image>
      <div class="added__images">
        <p class="ion-text-center">No Images Found.!</p>
      </div>
    </ng-template>
    <div class="add__image">
      <app-image-add (insert_image_attribute)="insert_image_attribute($event)"></app-image-add>
    </div>
  </div>
  <!-- </div> -->
  <!-- <div class="UppyDragDrop"></div> -->
</ion-content>
